<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item) in levelList" :key="item.path">
        <span class="no-redirect">
          <!--{{ item.meta.title }}-->
          {{routerName}}
        </span>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
  import pathToRegexp from 'path-to-regexp'

  export default {
    data() {
      return {
        levelList: null,
        routerName: '首页',
      }
    },
    watch: {
      $route(route) {
        // if you go to the redirect page, do not update the breadcrumbs
        if (route.path.startsWith('/redirect/')) {
          return
        }
        this.getBreadcrumb();
        this.routerName = route.name
      }
    },
    created() {
      this.routerName = this.$route.name;
      this.getBreadcrumb();
    },
    methods: {
      getBreadcrumb() {
        // only show routes with meta.title
        let matched = this.$route.matched.filter(item => item.meta && item.meta.title);
        const first = matched[0];

        if (!this.isDashboard(first)) {
          matched = [{path: '/HelloWorld', meta: {title: '首页'}}].concat(matched)
        }

        this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false);
      },
      isDashboard(route) {
        const name = route && route.name;
        if (!name) {
          return false
        }
        return name.trim().toLocaleLowerCase() === 'HelloWorld'.toLocaleLowerCase()
      },
      pathCompile(path) {
        // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
        const {params} = this.$route;
        var toPath = pathToRegexp.compile(path);
        return toPath(params)
      },
      handleLink(item) {
        const {redirect, path} = item;
        if (redirect) {
          this.$router.push(redirect);
          return
        }
        this.$router.push(this.pathCompile(path))
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/variables.scss";
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue